import React from "react";

interface TagListProps {
  tags: string[];
  onChange: (newTags: string[]) => void;
}

const TagList: React.FC<TagListProps> = ({ tags, onChange }) => {
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {tags.map((tag, idx) => (
        <span
          key={idx}
          className="bg-blue-100 text-blue-800 px-2 py-1 rounded flex items-center"
        >
          {tag}
          <button
            type="button"
            className="ml-2 text-red-500 hover:text-red-700"
            onClick={() => onChange(tags.filter((_, i) => i !== idx))}
          >
            ×
          </button>
        </span>
      ))}
    </div>
  );
};

export default TagList;
